var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#F2F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4537 47.9423C18.2345 48.1518 17.9579 48.2918 17.659 48.3445C17.3601 48.3972 17.0523 48.3603 16.7744 48.2384C16.4966 48.1165 16.2611 47.9151 16.098 47.6596C15.9348 47.4042 15.8512 47.1062 15.8578 46.8033C15.8643 46.5005 15.9608 46.2064 16.1348 45.9582C16.3089 45.7101 16.5527 45.5189 16.8356 45.4091C17.1185 45.2993 17.4277 45.2757 17.724 45.3412C18.0203 45.4067 18.2906 45.5585 18.5005 45.7773C18.781 46.071 18.9335 46.4638 18.9247 46.8695C18.916 47.2751 18.7466 47.6609 18.4537 47.9423Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.108 19.8654C47.8888 20.0749 47.6122 20.2149 47.3133 20.2676C47.0144 20.3203 46.7066 20.2834 46.4287 20.1615C46.1508 20.0396 45.9154 19.8381 45.7523 19.5827C45.5891 19.3273 45.5055 19.0293 45.5121 18.7264C45.5186 18.4236 45.6151 18.1295 45.7891 17.8813C45.9631 17.6332 46.207 17.442 46.4899 17.3322C46.7728 17.2224 47.082 17.1988 47.3783 17.2643C47.6746 17.3298 47.9449 17.4816 48.1548 17.7004C48.4353 17.9941 48.5878 18.3869 48.579 18.7926C48.5703 19.1982 48.4009 19.584 48.108 19.8654Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24.7143L23.2707 17.5564L35.5414 39.2857L23.2707 47.2105L11 24.7143Z",
    stroke: "#014935",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4879 16.7895L32.4728 15L28.127 37.2406L40.9089 39.5414L44.4879 16.7895Z",
    stroke: "#014935",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0292 38.2632L29.6608 29.0602L28.127 37.2406L35.0292 38.2632Z",
    fill: "#F05A28",
    stroke: "#014935",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.88 24.375H18.9251L19.9476 26.9274L18.6695 27.6932C19.217 28.8017 20.1156 29.6989 21.2258 30.2456L21.9928 28.9694L24.5492 29.9904V32.0323C24.5492 32.5962 24.0913 33.0533 23.5266 33.0533C19.3994 32.8029 16.1082 29.5168 15.8574 25.396C15.8574 24.8321 16.3152 24.375 16.88 24.375",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9939 25.9064V25.9115",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5271 25.9064V25.9115",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0603 25.9064V25.9115",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.60008,
    cy: 4.59582,
    rx: 4.60008,
    ry: 4.59582,
    transform: "matrix(0.894373 0.447321 -0.448429 0.893818 43.5098 24.3882)",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.53336,
    cy: 1.53194,
    rx: 1.53336,
    ry: 1.53194,
    transform: "matrix(0.894373 0.447321 -0.448429 0.893818 45.3379 27.5857)",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.33 32.3464C41.9497 31.6905 42.9269 31.5181 43.7342 31.9221L45.5627 32.8367C46.3713 33.2408 46.8182 34.1271 46.6616 35.0164",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.b503b57bf6981696f4d88dd2244468ee.svg";
export { ForwardRef as ReactComponent };